"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Class that keeps track of the popups currently displaying on the map (there
 * can be many). It allows different locations in the code to
 * activate/deactivate given popups without having to have/keep a reference to
 * it.
 *
 * TODO: Make this class map-implementation independent. At least as a first
 * step, the addPopup could send an html element instead of a popup object.
 *
 * @class MapPopupManager
 */
class MapPopupManager {
    // TODO Make map mandatory
    constructor(map) {
        this._popupsByName = {};
        this.map = map;
        this._popupsByName = {};
    }
    setMap(map) {
        this.map = map;
    }
    addPopup(popupName, popup) {
        if (!this._popupsByName[popupName] && this.map) {
            popup.addTo(this.map);
        }
        this._popupsByName[popupName] = popup;
    }
    removePopup(popupName) {
        if (this._popupsByName[popupName]) {
            this._popupsByName[popupName].remove();
        }
        delete this._popupsByName[popupName];
    }
    removeAllPopups() {
        for (const popupName in this._popupsByName) {
            this.removePopup(popupName);
        }
    }
}
exports.default = MapPopupManager;
//# sourceMappingURL=MapPopupManager.js.map